import axios from 'axios';

export const equipmentStoreConsumableApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/equipment-store-consumable`,
    headers: {
        'Content-Type': 'application/json'
    }
})